import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import useMedia from "use-media";
import { Label } from '../../atoms/label';
import { BlackCheckBox } from '../../atoms/blackCheckBox';
import arrow_bottom from "../../../resources/icons/ico_arrow_bottom.svg";
import arrow_top from "../../../resources/icons/ico_arrow_top.svg";
// 施設選択
const VacancyFacilityPopup = (props) => {
    const { initialShisetsuInfo,
        onDecice, // 決定処理
        onClose, // 閉じる処理
        show // ダイアログ表示状態
    } = props;

    const useMediaFlag = useMedia({ maxWidth: '480px' });
    const [isMobilePhone, setIsMobilePhone] = useState(false);
    // 施設情報 + チェック状態
    const [shisetsuInfo, setShisetsuInfo] = useState({});


    const popupRef = useRef(null);
    useLayoutEffect(() => {
        popupRef.current.scrollTop = 0;
    }, [show]);

    const copy = (obj) => {
        return JSON.parse(JSON.stringify(obj));
    }

    useEffect(() => {
        if (show) {
            // ポップアップ用にコピー
            setShisetsuInfo(initialShisetsuInfo ? copy(initialShisetsuInfo) : null)
        }
    }, [show, initialShisetsuInfo]);


    useEffect(() => {
        if (useMediaFlag) {
            setIsMobilePhone(true);
        } else {
            setIsMobilePhone(false);
        }
    }, [useMediaFlag]);


    // グループ選択
    const onChangeFacilityGroup = (hotelListKey, currentHotelList, groupIndex) => {
        const newShisetsuInfo = { ...shisetsuInfo, [hotelListKey]: toggleHotelGroupCheck(currentHotelList, groupIndex) };
        setShisetsuInfo(newShisetsuInfo);

    }

    // ホテルグループチェックを反転させる
    const toggleHotelGroupCheck = (currentHotelList, groupIndex) => {
        let currentChecked = currentHotelList[groupIndex].selected;
        const ret = [...currentHotelList];
        ret[groupIndex].selected = !currentChecked;
        ret[groupIndex].shisetsuList.forEach(item => {
            item.selected = !currentChecked
        })
        return ret;
    }

    // チェック状態変更
    const onChangeDetailConditionChecked = (hotelListKey, currentHotelList, groupIndex, index) => {
        const newShisetsuInfo = { ...shisetsuInfo, [hotelListKey]: toggleHotelCheck(currentHotelList, groupIndex, index) };
        setShisetsuInfo(newShisetsuInfo);


    }

    // ホテルチェックを反転させる
    const toggleHotelCheck = (currentHotelList, groupIndex, index) => {
        let currentChecked = currentHotelList[groupIndex].shisetsuList[index].selected;
        const ret = [...currentHotelList];
        ret[groupIndex].shisetsuList[index].selected = !currentChecked;
        const isAllChecked = !ret[groupIndex].shisetsuList.some(value => !value.selected);
        ret[groupIndex].selected = isAllChecked;
        return ret;
    }


    // グループ内施設表示/非表示
    const onClickArrow = (hotelListKey, currentHotelList, groupIndex) => {
        const newShisetsuInfo = { ...shisetsuInfo, [hotelListKey]: toggleHotelGroupDisp(currentHotelList, groupIndex) };
        setShisetsuInfo(newShisetsuInfo);

    }

    // ホテルグループチェックを反転させる
    const toggleHotelGroupDisp = (currentHotelList, groupIndex) => {
        const currentDisp = currentHotelList[groupIndex]["displayFlg"];
        const ret = [...currentHotelList];
        ret[groupIndex]["displayFlg"] = !currentDisp;
        return ret;
    }


    if (!shisetsuInfo) {
        return null;
    }

    return (
        <div className={show ? "popupIsShow" : "popup"} id="js-popup">
            <div className="popupInner" ref={popupRef}>
                <div className="popupHeader">
                    <div className="closeBtn" id="js-close-btn" onClick={onClose}>
                    </div>
                    <h4 className="popupInnerText" >エリア・施設</h4>
                </div>
                <Label className="popupTitle" label="会員制ホテル" />
                <HotelList
                    list={shisetsuInfo.memberHotelList}
                    listKey="memberHotelList"
                    onChangeFacilityGroup={onChangeFacilityGroup}
                    onClickArrow={onClickArrow}
                    onChangeDetailConditionChecked={onChangeDetailConditionChecked}
                    isMobilePhone={isMobilePhone}
                />
                {
                    shisetsuInfo.generalHotelList && shisetsuInfo.generalHotelList.length > 0
                    ? <>
                        <Label className="popupTitle" label="一般ホテル" />
                        <HotelList
                            list={shisetsuInfo.generalHotelList}
                            listKey="generalHotelList"
                            onChangeFacilityGroup={onChangeFacilityGroup}
                            onClickArrow={onClickArrow}
                            onChangeDetailConditionChecked={onChangeDetailConditionChecked}
                            isMobilePhone={isMobilePhone}
                        />
                    </>
                    : null
                }
                <div className="buttonArea buttonAreaSticky" >
                    <button id="checkListDecision" className="button" onClick={() => onDecice(shisetsuInfo)}>決 定</button>
                </div>
            </div>
            <div className="blackBackground" id="js-black-bg"></div>
        </div >
    );
};


const HotelList = (props) => {
    const { list,
        listKey,
        onChangeFacilityGroup,
        onClickArrow,
        onChangeDetailConditionChecked,
        isMobilePhone,
    } = props;
    if (!list) {
        return null;
    }

    return <>{list.map((group, groupIndex) => {
        return <div key={groupIndex}>
            <div style={{ display: "flex" }}>
                <BlackCheckBox
                    checkAreaStyle={isMobilePhone ? hotelListstyle.divItemTitleStyleSp : hotelListstyle.divItemTitleStyle}
                    id={"mainGroupCd" + group.mainGroupCd}
                    name={group.mainGroupCd}
                    // item={group.mainGroupName}
                    value={group.mainGroupCd}
                    checked={group.selected ? true : false}
                    onChange={() => onChangeFacilityGroup(listKey, list, groupIndex)} />
                <div onClick={() => onClickArrow(listKey, list, groupIndex)} style={{ display: "flex", alignItems: "center", marginTop: "10px", marginRight: "10px" }}>
                    <Label
                        label={group.mainGroupName}
                        style={{ hight: "auto", marginRight: "10px" }}
                    />
                    <img src={group.displayFlg ? arrow_top : arrow_bottom} alt="" className="arrowImg" />
                </div>
            </div>
            <div style={group.displayFlg ? isMobilePhone ? hotelListstyle.divStyleSp : hotelListstyle.divStyle : hotelListstyle.none}>
                {group.shisetsuList ? group.shisetsuList.map((shisetsu, index) => (
                    <div key={index}>
                        <BlackCheckBox
                            checkAreaStyle={shisetsu.openFlg ? isMobilePhone ? hotelListstyle.divItemStyleSp : hotelListstyle.divItemStyle : hotelListstyle.none}
                            key={index}
                            id={"shisetsuCd" + shisetsu.shisetsuCd}
                            name={shisetsu.shisetsuCd}
                            // className={d.class}
                            onChange={() => onChangeDetailConditionChecked(listKey, list, groupIndex, index)}
                            item={shisetsu.shisetsuName}
                            value={shisetsu.shisetsuCd}
                            checked={shisetsu.selected ? true : false}
                        // labelClassName={labelClassName}
                        />
                    </div>
                )) : null}
            </div>
        </div>
    })}</>;


}

const hotelListstyle = {
    divStyle: {
        // display: "flex",
        width: "80%",
        textAlign: "left",
        alignContent: "center",
        margin: "0px 5% 20px 10%",
        fontSize: "small",
        // flexWrap: "wrap",
    },
    divStyleSp: {
        // display: "flex",
        // flexWrap: "wrap",
        textAlign: "left",
        alignContent: "center",
        padding: "0px 5% 20px 10%",
        fontSize: "small",
        justifyContent: "space-between",
    },
    divItemStyle: {
        // display: "flex",
        // flexWrap: "wrap",
        // width: "33%",
        textAlign: "left",
        alignContent: "center",
        fontSize: "small",
        margin: "15px 0px 0px 0px",
    },
    divItemStyleSp: {
        // width: "48%",
        textAlign: "left",
        margin: "20px 0px 0px 0px",
    },
    divItemTitleStyle: {
        padding: "10px 0% 10px 5%",
        color: "#696969",
        justifyContent: "left",
        fontWeight: "bold",
    },
    divItemTitleStyleSp: {
        textAlign: "left",
        padding: "10px 0% 10px 5%",
        color: "#696969",
        fontWeight: "bold",
    },
    none: {
        display: "none"
    }
}

export default VacancyFacilityPopup;